<div class="container">
  <div
    class="goods-services"
    #goodsAndServicesContainer
    matTooltip="{{ goodsAndServices }}"
    matTooltipPosition="left"
    matTooltipClass="ellipsed-text-mattooltip"
  >
    {{ goodsAndServices }}
  </div>
  @if (checkOverflow(goodsAndServicesContainer)) {
  <div class="link">
    <a
      (click)="openGoodsAndServicesDialog()"
      i18n="@@GoodsAndServicesRendererViewAllTermsButton"
      >View All Terms</a
    >
  </div>
  }
</div>
